import { IconButton, TableCell } from "@material-ui/core"
import { Delete as DeleteIcon } from "@material-ui/icons"
import { SubscriptionList } from "@root/store/types"
import React from "react"

export interface Props {
  list: SubscriptionList
  onRemoveList: (listId: string) => void
}

const UnscopedListItem: React.FC<Props> = ({ list, onRemoveList }) => {
  return (
    <>
      <TableCell component="th" scope="row">
        {list.id}
      </TableCell>
      <TableCell align="right" padding="none" size="small">
        <IconButton
          onClick={() => onRemoveList(list.id)}
          data-qa-selector="delete"
        >
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </>
  )
}

export default UnscopedListItem
